export const getInitials = (name) => {
  const nameArray = name?.split(" ") || [];
  const firstNameIn = nameArray[0]?.charAt(0)?.toUpperCase() || "A";
  const lastNameIn =
    nameArray[nameArray.length - 1]?.charAt(0)?.toUpperCase() || "A";

  return firstNameIn + lastNameIn;
};
